import { UncontrolledTooltip } from 'reactstrap';

function ReviewingLastQuizNotice({ className }) {
  return (
    <>
      <span id="reviewing-last-quiz" className={className || 'review__textbox'}>
        Reviewing last quiz
      </span>
      <UncontrolledTooltip placement="top" target="reviewing-last-quiz">
        The &apos;Last Quiz&apos; refers to the most recent re-take of the
        selected quiz. If no re-take has been completed, it refers to the
        original quiz attempt.
      </UncontrolledTooltip>
    </>
  );
}
export default ReviewingLastQuizNotice;
